<template>
  <div class="app-container" v-loading="pageLoading">
    <el-card shadow="never">
      <div slot="header" class="flex flex-ac flex-sb">
        <span>{{
          isEdit ? '修改VIP升级消息模板' : '新增VIP升级消息模板'
        }}</span>
      </div>

      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="140px"
        class="vip-template-form"
      >
        <div class="lang-item-header" v-if="isEdit">
          中文名：{{ form.name }}
        </div>
        <div class="lang-item-header" v-if="isEdit">
          英文名：{{ form.name_en }}
        </div>
        <el-form-item label="目标VIP等级编号" prop="vip_level_no">
          <el-input-number
            v-model="form.vip_level_no"
            :min="1"
            :precision="0"
            :disabled="isEdit"
            controls-position="right"
            style="width: 220px"
          />
        </el-form-item>

        <el-form-item label="是否启用模板" prop="enabled">
          <el-switch
            v-model="form.enabled"
            active-text="启用"
            inactive-text="停用"
          />
          <div class="form-tip">关闭后该等级升级时不发送消息</div>
        </el-form-item>

        <el-divider>多语言模板配置</el-divider>

        <!-- <div class="tips-box">
          可用变量：<code>{user_name}</code>、<code>{level_name}</code>
        </div> -->

        <div
          v-for="(item, index) in form.lang_list"
          :key="index"
          class="lang-item"
        >
          <div class="lang-item-header">
            <!-- <span>语言配置 {{ index + 1 }}</span> -->
            <span>{{ item.label }}</span>
            <!-- <el-button
              v-if="form.lang_list.length > 1"
              type="text"
              style="color: #f56c6c"
              @click="removeLang(index)"
            >
              删除
            </el-button> -->
          </div>

          <!-- <el-form-item
            :label="'语言'"
            :prop="'lang_list.' + index + '.lang'"
            :rules="[
              {
                required: true,
                message: '请选择/输入语言编码',
                trigger: 'change',
              },
            ]"
          >
            <el-select
              v-model="item.lang"
              filterable
              allow-create
              default-first-option
              placeholder="如：zh-CN / en_US"
              style="width: 260px"
            >
              <el-option
                v-for="opt in langOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
          </el-form-item> -->

          <el-form-item
            :label="'标题'"
            :prop="'lang_list.' + index + '.title'"
            :rules="[
              { required: true, message: '请输入标题', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="item.title"
              maxlength="100"
              show-word-limit
              placeholder="例如：恭喜升级 {level_name}"
            />
          </el-form-item>

          <el-form-item
            :label="'内容'"
            :prop="'lang_list.' + index + '.content'"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="item.content"
              type="textarea"
              :rows="4"
              show-word-limit
              placeholder="例如：亲爱的 {user_name}，您已成功升级至 {level_name}！"
            />
          </el-form-item>
        </div>

        <!-- <el-form-item>
          <el-button type="primary" plain icon="el-icon-plus" @click="addLang">
            新增语言
          </el-button>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" :loading="submitLoading" @click="submit">
            保存
          </el-button>
          <el-button @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'VipUpgradeTemplateEdit',
  data() {
    return {
      isEdit: false,
      pageLoading: false,
      submitLoading: false,
      form: {
        vip_level_no: undefined,
        enabled: true,
        lang_list: [
          {
            lang: 'zh-CN',
            label: '简体中文',
            title: '',
            content: '',
          },
          {
            lang: 'en_US',
            label: 'English',
            title: '',
            content: '',
          },
        ],
      },
      langOptions: [
        { label: '简体中文 (zh-CN)', value: 'zh-CN' },
        { label: '繁体中文 (zh-TW)', value: 'zh-TW' },
        { label: 'English (en_US)', value: 'en_US' },
        { label: 'Tiếng Việt (vi_VN)', value: 'vi_VN' },
        { label: 'ไทย (th_TH)', value: 'th_TH' },
        { label: '日本語 (ja_JP)', value: 'ja_JP' },
        { label: '한국어 (ko_KR)', value: 'ko_KR' },
      ],
      rules: {
        vip_level_no: [
          {
            required: true,
            message: '请输入目标VIP等级编号',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    const vipLevelNo =
      this.$route.query.vip_level_no || this.$route.query.level_no
    if (vipLevelNo !== undefined && vipLevelNo !== null && vipLevelNo !== '') {
      this.isEdit = true
      this.form.vip_level_no = Number(vipLevelNo)
      this.getDetail()
    }
  },
  methods: {
    getDefaultLangItem() {
      return {
        lang: '',
        title: '',
        content: '',
      }
    },

    addLang() {
      this.form.lang_list.push(this.getDefaultLangItem())
    },

    removeLang(index) {
      this.form.lang_list.splice(index, 1)
    },

    getLangLabel(lang) {
      const hit = this.langOptions.find((x) => x.value === lang)
      return hit ? hit.label.split(' (')[0] : lang
    },

    async getDetail() {
      this.pageLoading = true
      try {
        const res = await request({
          url: '/api/backend/vipLevelConfig/upgradeMessageDetail',
          method: 'get',
          params: {
            vip_level_no: this.form.vip_level_no,
          },
        })
        const detail = res && res.data ? res.data : {}
        const template = detail.template || null
        this.form.vip_level_no = detail.level_no
        this.form.enabled = template ? template.enabled : true
        this.form.name = detail.name
        this.form.name_en = detail.name_en
        let langList = []
        if (template && Array.isArray(template.lang_list)) {
          langList = template.lang_list.map((item) => ({
            lang: item.lang || '',
            label: this.getLangLabel(item.lang || ''),
            title: item.title || '',
            content: item.content || '',
          }))
        }

        this.form.lang_list =
          langList.length > 0
            ? langList
            : [
                { lang: 'zh-CN', label: '简体中文', title: '', content: '' },
                { lang: 'en_US', label: 'English', title: '', content: '' },
              ]
      } finally {
        this.pageLoading = false
      }
    },

    validateLangList() {
      if (
        !Array.isArray(this.form.lang_list) ||
        this.form.lang_list.length < 1
      ) {
        this.$message.warning('请至少配置一种语言模板')
        return false
      }

      const langSet = new Set()
      for (let i = 0; i < this.form.lang_list.length; i++) {
        const row = this.form.lang_list[i]
        const lang = (row.lang || '').trim()
        const title = (row.title || '').trim()
        const content = (row.content || '').trim()

        if (!lang || !title || !content) {
          this.$message.warning(`第 ${i + 1} 条语言配置未填写完整`)
          return false
        }
        if (langSet.has(lang)) {
          this.$message.warning(`语言 ${lang} 重复，请去重`)
          return false
        }
        langSet.add(lang)
      }

      return true
    },

    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        if (!this.validateLangList()) return

        const payload = {
          vip_level_no: Number(this.form.vip_level_no),
          enabled: Boolean(this.form.enabled),
          lang_list: this.form.lang_list.map((i) => ({
            lang: (i.lang || '').trim(),
            title: (i.title || '').trim(),
            content: (i.content || '').trim(),
          })),
        }

        this.submitLoading = true
        try {
          await request({
            url: '/api/backend/vipLevelConfig/upgradeMessageStore',
            method: 'post',
            data: payload,
          })
          this.$message.success('保存成功')
          this.goBack()
        } finally {
          this.submitLoading = false
        }
      })
    },

    goBack() {
      this.$router.push('/operation/vipupgradetemplate')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.vip-template-form {
  max-width: 900px;
}
.form-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
}
.tips-box {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  color: #606266;
  font-size: 12px;
}
.lang-item {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 14px 14px 0;
  margin-bottom: 12px;
}
.lang-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #303133;
  font-weight: 500;
}
</style>
